import { noValidation } from '@post-office/message-maker-browser/message-helpers';
import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--growth/test-placement-v2-example';
import { TestMessage } from '../../../components/test-message';

export const MessageFrontend: ReturnType<typeof PlacementFrontend.createMessageFrontend> =
	PlacementFrontend.createMessageFrontend({
		render: {
			validate: noValidation<PlacementRenderProps>(),
			Component: ({ dismiss }: PlacementRenderProps) => <TestMessage onDismiss={dismiss} />,
		},
	});
